import React from 'react';

class SelectQuestion extends React.Component {


  generateOptions = (options, predefinedValue, field) => {
    return options.map( (option, key) => {
      if(predefinedValue === option.value){
        return <option value={option.value} id={`${field}-${key}`} key={`${field}-${key}`} selected>{option.text} </option>
      }
      return <option value={option.value} id={`${field}-${key}`} key={`${field}-${key}`}>{option.text} </option>
    });
  }

  onChangeHandler= (e) => {
    const {value} = e.target;
    const {field} = this.props;

    //Cambiar estados
    this.props.handleChangeListener(field, value, null, null, null);
  }

  render() {
    const {field,text,note,predefinedValue, errors, isError} = this.props;
    const errorList = errors !== null? errors.map( (error) =>  <li key={error}>{error}</li>) : null
    const options = this.generateOptions(this.props.options, predefinedValue, field);

    return (
      <div className="select">
          <div className="form-group">
              <label htmlFor={field}>{text}</label>
              <select className="form-control" 
                name={field}
                onChange={this.onChangeHandler}
                predefinedvalue={this.predefinedValue}
              >
                {
                  options
                }
              </select>
              <p className="question-subinstruction">{note}</p>
              {isError === true ? 
                <ul className="error">
                  {errorList}
                </ul>
                : null
              }    
          </div>
      </div>
    );
  }
}

export default SelectQuestion;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/QuestionsTypes/SelectQuestion.js